import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectUserCountryDetails } from '../../../redux/appointmentForm/selectors';
import { selectCountryList } from '../../../redux/data/selectors';

export function usePatientCountryDetails() {
  const userCountryName = useSelector(selectUserCountryDetails);
  const targetCountry = useSelector(selectCountryList).find(
    ({ name }) => name === userCountryName,
  );

  if (!targetCountry) return null;

  const targetCountryEntity = {
    label: targetCountry.name,
    value: targetCountry.isoCode,
  };

  return useMemo(() => targetCountryEntity, [userCountryName, targetCountry]);
}



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPatientInfo/usePatientCountryDetails.js